import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-multi-factor-authentification-new-device',
  templateUrl: './multi-factor-authentification-new-device.component.html',
  styleUrls: ['./multi-factor-authentification-new-device.component.scss']
})
export class MultiFactorAuthentificationNewDeviceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
